import React from "react";
import { motion } from "framer-motion";

function Loading() {
  return (
    <div className="flex items-center z-50 justify-center min-h-screen bg-gray-100 w-full">
      <motion.div
        initial={{ opacity: 0, scale: 0.8 }}
        animate={{ opacity: 1, scale: 1 }}
        transition={{ duration: 1, ease: "easeInOut", repeat: Infinity, repeatType: "reverse" }}
        className="flex flex-col items-center"
      >
        <img
          src={process.env.PUBLIC_URL + "/assets/Logo.jpg"}
          alt="Loading"
          className="w-24 h-24 md:w-72 md:h-72 object-contain"
        />
   
      </motion.div>
    </div>
  );
}

export default Loading;
